<div class="plot-container">
  <div class="helper-container" draggable="true">
    <svg id="point-helper"></svg>
  </div>
  <div class="legends-container">
    <svg id="legends" draggable="true"></svg>
  </div>
  <svg id="chart"></svg>
</div>
